import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { PleaseBePatientComponent } from '../../../../components/please-be-patient/please-be-patient.component';
import type { Legal } from '../../kws.model';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrl: './legal.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
  ],
})
export class LegalComponent
  extends BaseModalComponent<
    {
      bankaddress: string;
      organisation: string;
      name: string;
      street: string;
      city: string;
      email: string;
      fax: string;
      wwww: string;
      phone: string;
    },
    Legal
  >
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  ngOnInit(): void {
    this.form.setValue({
      bankaddress: this.bankaddress,
      organisation: this.organisation,
      name: this.name,
      street: this.street,
      city: this.city,
      email: this.email,
      fax: this.fax,
      www: this.www,
      phone: this.phone,
    });
  }

  bankaddress: string;
  organisation: string;
  name: string;
  street: string;
  city: string;
  email: string;
  fax: string;
  www: string;
  phone: string;

  form = new SubmittableForm({
    bankaddress: new FormControl(''),
    organisation: new FormControl(''),
    name: new FormControl(''),
    street: new FormControl(''),
    city: new FormControl(''),
    email: new FormControl(''),
    fax: new FormControl(''),
    www: new FormControl(''),
    phone: new FormControl(''),
  });

  abort() {
    this.close();
  }

  get formNotTouched() {
    return this.form.pristine;
  }

  submit() {
    const result = this.form.value;
    this.result = {
      bankaddress: result.bankaddress,
      privacyOfficer: {
        organisation: result.organisation,
        name: result.name,
        street: result.street,
        city: result.city,
        fax: result.fax,
        email: result.email,
        www: result.www,
        phone: result.phone,
      },
    };
    this.close();
  }
}
